"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ShapeGroup;
    }
});
const _BaseGroup = /*#__PURE__*/ _interop_require_default(require("./BaseGroup.js"));
const _KonvaTextLabel = /*#__PURE__*/ _interop_require_default(require("../KonvaShapes/KonvaTextLabel.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
class ShapeGroup extends _BaseGroup.default {
    /**
   * Executes actions after updating the shape, including drawing the label and stroke.
   * @private
   */ _afterUpdate() {
        this.drawStroke(true);
        this.drawLabel(true);
    }
    /**
   * Placeholder method for defining the stroke shape.
   * This method can be optionally defined by subclasses to customize the stroke shape.
   * If not overridden, it returns null.
   * @param {object} shape - The shape object to be stroked.
   * @param {object} config - Configuration options for stroke customization.
   * @returns {object|null} The customized stroke shape, or null if not customized.
   * @private
   */ _stroke(shape = {}, config = {}) {
        // Placeholder for an optional stroke shape customization.
        // If not overridden by subclasses, returns null.
        return null;
    }
    /**
   * Returns configuration options for the label.
   * @returns {object} - Label configuration.
   * @private
   */ _labelConfig() {
        // optional config override
        return {};
    }
    /**
   * Draws the label for the shape group.
   * @param {boolean} [visible=true] - Indicates whether the label should be visible.
   */ drawLabel(visible = true) {
        if (this.label) {
            this.label.destroy();
        }
        if (!visible) return;
        this.label = (0, _KonvaTextLabel.default)(_object_spread({}, this.shape, this._labelConfig()), {
            rotation: -this._rotation,
            draggable: false,
            editable: this.editable,
            onTextChange: this.onTextChange
        });
        if (this.label) this.add(this.label);
    }
    /**
   * Draws the stroke for the shape group.
   * @param {boolean} [visible=true] - Indicates whether the stroke should be visible.
   */ drawStroke(visible = true) {
        if (this.strokeShape) {
            this.strokeShape.destroy();
        }
        if (!visible) return;
        this.strokeShape = this._stroke();
        if (this.strokeShape) this.add(this.strokeShape);
    }
}
